import { Card, Table, Button } from "@mui/material"
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getBizID, getServices, getStyle } from "../../libs/todoSlice";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { WindowSharp } from "@mui/icons-material";
import fontColor from "../../lib/fontColor";


function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}
const rows = [
    createData('Frozen yoghurt', 159, "2021-12-04", "Pending", 4.0),
    createData('Ice cream sandwich', 237, "2041-07-04", "Active", 4.3),
    createData('Eclair', 262, "2011-12-14", "Pending", 6.0),
    createData('Cupcake', 305, "2021-12-07", "Pending", 4.3),
    createData('Gingerbread', 356, "2071-02-04", "Pending", 3.9),
];

const ApproveUserToBiz = () => {


    const params = useParams()
    const navigate = useNavigate()
    const biz_id = useSelector(getBizID)
    const style = useSelector(getStyle)
    const service = useSelector(getServices)

    const ButtonStyle = {
        margin: '5px',
        borderRadius: '4px',
        width: 'fit-content',
        height: '25px',
        marginBottom: '5px',
        padding: '5px',
        border: '1px solid',
        fontSize: '12px',
        lineHeight: '10px',
    }

    const ManageButtonStyle = {
        borderRadius: 6, height: 28, margin: 4, color: 'white',
    }

    const [searchtext, setSearchText] = useState('')
    const [data, setData] = useState()
    const [defaultData, setDefaultData] = useState()

    useEffect(() => {
        if (service.some(item => item === "manage-business-enrollment") !== true) {
            navigate(`/${params.prefix}/`)
        }
        getData()
    }, [])

    const getData = async () => {
        try {
            const { data } = await axios({
                method: 'GET',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/doctor/enrollments?business_id=${biz_id}`,
            })
            setData(data.data.map(item => {
                return {
                    name: item.preRegister.specialTitleTH + " " + item.preRegister.firstNameTH + " " + item.preRegister.lastNameTH,
                    ...item
                }
            }))
            setDefaultData(data.data.map(item => {
                return {
                    name: item.preRegister.specialTitleTH + " " + item.preRegister.firstNameTH + " " + item.preRegister.lastNameTH,
                    ...item
                }
            }))
        }
        catch (err) {
            console.log('err :>> ', err);
        }
    }

    const convertDate = (dateValue) => {
        const dateString = dateValue;
        const date = new Date(dateString);

        // Get the year, month, and day components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Add 1 to month since it's zero-based
        const day = String(date.getDate()).padStart(2, '0');

        // Create the formatted date string
        const formattedDate = `${day}-${month}-${year}`;

        return formattedDate
    }

    const allowtoBiz = async (id) => {
        try {
            await axios({
                method: 'PUT',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/doctor/enrollments/${id}/${biz_id}`,
            })
            Swal.fire({
                icon: 'success',
                title: 'อนุมัติเรียบร้อยแล้ว',
            })
            getData()
        }
        catch (err) {
            console.log('err :>> ', err);
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: 'ไม่สามารถอนุมัติบุคคลนี้ได้',
            })
        }
    }

    const cancletoBiz = async (id) => {
        try {
            await axios({
                method: 'DELETE',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/doctor/enrollments/${id}/${biz_id}`,
            })
            Swal.fire({
                icon: 'success',
                title: 'ปฏิเสธเรียบร้อยแล้ว',
            })
            getData()
        }
        catch (err) {
            console.log('err :>> ', err);
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: 'ไม่สามารถปฏิเสธบุคคลนี้ได้',
            })
        }
    }



    return (
        <>
            <div>
                <h3 style={{ color: 'black', fontWeight: 'bold', margin: 10, marginBottom: 30 }}>หน้าจัดการคนเข้าสู่องค์กร</h3>
            </div>
            <Card style={{ borderRadius: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>


                    <div
                        style={{
                            position: 'relative',
                            display: 'inline-block',
                            margin: 20,
                            marginTop: 5
                        }}>
                        <input
                            placeholder="ค้นหาชื่อ, ตำแหน่ง,สถานะ"
                            value={searchtext}
                            style={{
                                position: 'relative',
                                width: '380px',
                                height: '36px',
                                border: '1px solid #EEEEEE',
                                backgroundColor: '#FFFFFF',
                                borderRadius: '6px',
                                marginTop: '40px',
                                marginRight: '15px',
                                marginBottom: '10px',
                                padding: '10px',
                                paddingRight: '2.5rem'
                            }}
                            onChange={(e) => {
                                setSearchText(e.target.value);
                                if (e.target.value === '') {
                                    setData(defaultData);
                                } else {
                                    const filterData = defaultData.filter(item => {
                                        return (
                                            item.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
                                            item.preRegister.position === e.target.value ||
                                            item.preRegister.status.toLowerCase() === e.target.value.toLowerCase() ||
                                            convertDate(item.preRegister.updatedAt).includes(e.target.value)
                                        )
                                    });
                                    setData(filterData);
                                }
                            }}
                        >
                        </input>
                        <SearchIcon
                            style={{
                                position: 'absolute',
                                top: '54%',
                                left: '21.5rem',
                                color: '#DADADA',
                            }}
                        />
                    </div>
                    <Button variant="contained"
                        style={{ width: 200, height: 40, marginLeft: 'auto', marginRight: 30, marginTop: 12 }}
                        sx={!!style.primary_color && {
                            backgroundColor: `${style.secondary_color} !important`,
                            color: fontColor(style.secondary_color)
                        }}
                        onClick={() => { window.open("https://checkmd.tmc.or.th/") }}
                    >
                        ตรวจสอบข้อมูลแพทย์</Button>
                </div>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead >
                            <TableRow >
                                <TableCell style={{ fontWeight: 800 }} align="left">ชื่อ-สกุล</TableCell>
                                <TableCell style={{ fontWeight: 800 }} align="center">ตำแหน่ง</TableCell>
                                <TableCell style={{ fontWeight: 800 }} align="center">วันที่</TableCell>
                                <TableCell style={{ fontWeight: 800 }} align="center">สถานะ</TableCell>
                                <TableCell style={{ fontWeight: 800 }} align="center">การจัดการ</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data && data.map((item) => (
                                <TableRow
                                    key={item.name}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="item">
                                        {item.name}
                                    </TableCell>
                                    <TableCell align="center">{item.preRegister.position}</TableCell>
                                    <TableCell align="center">{item.preRegister.updatedAt && convertDate(item.preRegister.updatedAt)}</TableCell>
                                    <TableCell align="center">{
                                        item.preRegister.status === 'active' ?
                                            <button style={{
                                                ...ButtonStyle,
                                                borderColor: 'rgb(0 190 80)',
                                                color: 'rgb(0 190 80)',
                                                backgroundColor: 'rgb(228 255 236)',
                                            }}
                                            >Active</button>
                                            :
                                            <button style={{
                                                ...ButtonStyle,
                                                borderColor: '#ff9900',
                                                color: '#ff9900',
                                                backgroundColor: '#ffefd8',
                                            }}
                                            >Pending</button>
                                    }</TableCell>
                                    <TableCell align="center">
                                        <Button variant="contained" style={{ ...ManageButtonStyle, backgroundColor: 'rgb(0 190 80)' }} onClick={() => { allowtoBiz(item._id) }}>
                                            อนุมัติ
                                        </Button>
                                        <Button variant="contained" style={{ ...ManageButtonStyle, backgroundColor: 'red' }} onClick={() => { cancletoBiz(item._id) }}>
                                            ปฏิเสธ
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Card >
        </>
    )
}

export default ApproveUserToBiz